<template>
  <div class="s-join" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <img v-if="btnJoin.src" :src="btnJoin.src" :style="{...btnJoin.style}" alt="" @click="JoinFun">
    <SVersionModalJoinTeam ref="SVersionModalJoinTeam"  @joinSuccess="joinSuccess"/>
  </div>
</template>
<script>

import SAnimateImage from '../AnimateImage/index.vue'
import SVersionModalJoinTeam from './_components/VersionModalJoinTeam.vue'

export default {
  name: 'SVersionJoin',
  components: { SVersionModalJoinTeam, SAnimateImage },
  props: {
    activityId: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    btnJoin: {
      type: Object,
      default: () => {
        return {}
      }
    },
    request: {
      type: Function
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 加入按钮
    JoinFun () {
      this.$refs.SVersionModalJoinTeam.open({
        activityId: this.activityId
      })
    },
    // 加入成功
    joinSuccess() {
      this.$MainWrap.init && this.$MainWrap.init()
    }
  }
}
</script>
<style lang="scss" scoped>
.s-join{
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
</style>
